import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

/**
 * A placeholder that holds the exact space the real content will take, so
 * nothing jumps when it arrives. It shimmers rather than blinks — a pulse at
 * this size reads as something going wrong.
 */
export function Skeleton({ className, ...props }: ComponentProps<"div">) {
  return (
    <div aria-hidden className={cn("animate-shimmer h-4 rounded-md", className)} {...props} />
  );
}

/** A block of skeleton lines, for a paragraph or a stack of rows. */
export function SkeletonLines({ rows = 3, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn("grid gap-2", className)}>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className={index === rows - 1 ? "w-2/3" : "w-full"} />
      ))}
    </div>
  );
}
